<div class="container">
  <div class="crew-header">
    <mat-form-field appearance="outline">
      <mat-label>From Date - To Date</mat-label>
      <mat-date-range-input [rangePicker]="picker" [max]="currDate">
        <input matStartDate matInput [(ngModel)]="fromDate" [disabled]="!loaded" placeholder="From date" />
        <input matEndDate matInput [(ngModel)]="toDate" [disabled]="!loaded" (ngModelChange)="onDateChanged()"
          placeholder="To date" />
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <button mat-flat-button class="remove" [hidden]=" ( toDate == null ) || !loaded" (click)="reset()">
      <mat-icon>refresh</mat-icon>
    </button>
    <button mat-raised-button color="primary" class="button ml-auto" [disabled]="activityDate.length == 0 || !loaded"
      (click)="onExport()">
      <mat-icon>sim_card_download</mat-icon>
      Export
    </button>
  </div>
  <div class="overflow-x-scroll" *ngIf="loaded; else loading">
    <div class="crew-tabel">
      <div class="tabel-head">
        <div>
          <span>{{ listData.header.action }}</span>
        </div>
        <div>
          <span>{{ listData.header.actionBy }}</span>
        </div>
        <div>
          <span>{{ listData.header.client }}</span>
        </div>
        <div>
          <span>{{ listData.header.category }}</span>
        </div>
        <div>
          <span>{{ listData.header.createdDate }}</span>
        </div>
        <div>
          <span>{{ listData.header.statusStr }}</span>
        </div>
        <div>
          <span>{{ listData.header.fileLink }}</span>
        </div>
      </div>

      <div *ngIf="activityDate.length != 0; else noData" class="tabel-container thin-scroll mg-scroll">
        <div class="toper" *ngFor="let date of activityDate">
          <div class="toperHead">{{ date }}</div>
          <div class="tab-con">
            <div class="tabel-body" *ngFor="let item of activityList[date]; let i = index">
              <div class="body-ele">
                <span>{{ item.action }}</span>
              </div>
              <div class="body-ele">
                <span>{{ item.actionBy }}</span>
              </div>
              <div class="body-ele">
                <span>{{ item.client }}</span>
              </div>
              <div class="body-ele">
                <span>{{ item.category }}</span>
              </div>
              <div class="body-ele">
                <span>{{ _date(item.createdDate) | date: "medium" }}</span>
              </div>
              <div class="body-ele">
                <span>{{ item.statusStr }}</span>
              </div>
              <div class="body-ele" >
                <span *ngIf="item.fileLink != null" >
                  <span *ngIf="item.fileLink.length == 1">
                    <i title="{{item.fileLink[0].split('/').pop()}}" (click)="fileLink( item.fileLink[0] )"><mat-icon>insert_drive_file</mat-icon></i>
                  </span>
                  <span *ngIf="item.fileLink.length == 2">
                    <i title="{{item.fileLink[0].split('/').pop()}}" (click)="fileLink( item.fileLink[0] )"><mat-icon>insert_drive_file</mat-icon></i>
                    <span class="space" style="width: 10px; display: inline-block;"></span>
                    <i title="{{item.fileLink[1].split('/').pop()}}" (click)="fileLink( item.fileLink[1] )"><mat-icon>insert_drive_file</mat-icon></i>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #noData>
        <div class="tabel-con">
          <img src="../../../../assets/noData.svg" width="170" alt="">
          <span class="mt-4"> No Activity Found</span>
        </div>
      </ng-template>

    </div>
  </div>
</div>
<ng-template #loading>
  <div class="center loading">
    <span class="d">.</span><span class="d d-2">.</span><span class="d d-3">.</span>
  </div>
</ng-template>
